// Copyright (c) 2024 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {getFactoryDuplicatePinPlateResults, processFactoryDuplicatePinPlates} from '../../shared/repositories';
import actions from '../../actions-list';

export const updateFactoryDuplicatePinPlateResults = () =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        const factoryStatus = ['APPROVED', 'INPROCESS'];

        try {

            const factoryPinPlateResult = await getFactoryDuplicatePinPlateResults(factoryStatus);

            dispatch({
                data: factoryPinPlateResult,
                type: actions.UPDATE_FACTORY_PIN_PLATE_RESULTS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const updateSelectedPinPlates = selectedItems =>

    dispatch => {

        dispatch({
            data: selectedItems,
            type: actions.UPDATE_FACTORY_PIN_PLATE_SELECTED_ITEMS
        });

    };

export const processSelectedPinPlates = pinPlateIds =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await processFactoryDuplicatePinPlates(pinPlateIds);

            dispatch(updateFactoryDuplicatePinPlateResults());

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const resetRegistrationReviewFacets = allowedDealers =>

    dispatch => {

        dispatch({
            allowedDealers,
            type: actions.RESET_REGISTRATION_FACETS
        });

    };



// WEBPACK FOOTER //
// ./src/product/factory-users-duplicate-pin-plate/action-creators/factory-duplicate-pin-plates.js